import { render, staticRenderFns } from "./ModalChargeDetail.vue?vue&type=template&id=bbf53b5c&scoped=true&"
import script from "./ModalChargeDetail.vue?vue&type=script&lang=js&"
export * from "./ModalChargeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalChargeDetail.vue?vue&type=style&index=0&id=bbf53b5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf53b5c",
  null
  
)

export default component.exports